import { apiConstants } from '../../apiConstant'
import { formDataCommonFunction } from '../../serviceCall'

export const getTicketMessageThreadApi = (data, callback, errorCallBack) => {
  return async (dispatch) => {
    formDataCommonFunction(data,apiConstants.TICKET.GET_TICKET_MESSAGE_THREAD)
      .then((response) => {
        callback && callback(response.data)
      })
      .catch((error) => {
        errorCallBack && errorCallBack(error.response)
      })
  }
}
